import { useLang } from '@/i18n';
import EfIcon from '@elem/ui/ef-icon';
import EfProductCompareC from '@elem/ui/ef-product-compare-c';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('theProduct.TabC');
    const listA = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724576382789/cc1.png',
        title: t('win3_a_title'),
        specList: [
            {
                desc: t('win3_a_item1_t'),
                title: (
                    <div className="win3_item_title">
                        <EfIcon className="win3_item_title_icon" pc="https://websiteoss.ecoflow.com/upload/image/1723727559364/d1.png" />
                        <div className="win3_item_title_text">{t('win3_a_item1_b')}</div>
                    </div>
                ),
            },
            {
                desc: t('win3_a_item2_t'),
                title: (
                    <div className="win3_item_title">
                        <EfIcon className="win3_item_title_icon" pc="https://websiteoss.ecoflow.com/upload/image/1723728127710/d2.png" />
                        <div className="win3_item_title_text">{t('win3_a_item2_b')}</div>
                    </div>
                ),
            },
            {
                desc: t('win3_a_item3_t'),
                title: (
                    <div className="win3_item_title">
                        <EfIcon className="win3_item_title_icon" pc="https://websiteoss.ecoflow.com/upload/image/1723728163210/d3.png" />
                        <div className="win3_item_title_text">{t('win3_a_item3_b')}</div>
                    </div>
                ),
            },
            {
                desc: t('win3_a_item4_t'),
                title: (
                    <div className="win3_item_title">
                        <EfIcon className="win3_item_title_icon" pc="https://websiteoss.ecoflow.com/upload/image/1723728127912/d4.png" />
                        <div className="win3_item_title_text">{t('win3_a_item4_b')}</div>
                    </div>
                ),
            },
        ],
    };

    const listB = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724576382613/cc2.png',
        title: t('win3_b_title'),
        specList: [
            {
                desc: t('win3_b_item1_t'),
                title: (
                    <div className="win3_item_title">
                        <EfIcon className="win3_item_title_icon" pc="https://websiteoss.ecoflow.com/upload/image/1723727559364/d1.png" />
                        <div className="win3_item_title_text">{t('win3_b_item1_b')}</div>
                    </div>
                ),
            },
            {
                desc: t('win3_b_item2_t'),
                title: (
                    <div className="win3_item_title">
                        <EfIcon className="win3_item_title_icon" pc="https://websiteoss.ecoflow.com/upload/image/1723728127710/d2.png" />
                        <div className="win3_item_title_text">{t('win3_b_item2_b')}</div>
                    </div>
                ),
            },
            {
                desc: t('win3_b_item3_t'),
                title: (
                    <div className="win3_item_title">
                        <EfIcon className="win3_item_title_icon" pc="https://websiteoss.ecoflow.com/upload/image/1723728163210/d3.png" />
                        <div className="win3_item_title_text">{t('win3_b_item3_b')}</div>
                    </div>
                ),
            },
            {
                desc: t('win3_b_item4_t'),
                title: (
                    <div className="win3_item_title">
                        <EfIcon className="win3_item_title_icon" pc="https://websiteoss.ecoflow.com/upload/image/1723728127912/d4.png" />
                        <div className="win3_item_title_text">{t('win3_b_item4_b')}</div>
                    </div>
                ),
            },
        ],
    };

    const listAll = [listA, listB];
    return (
        <div className={styles.Win3}>
            <EfProductCompareC items={listAll} theme="transparent" />
        </div>
    );
}
